export class SupportToken {
    public deployments: number[];
    public validHours: number;
    constructor(data?: Object) {
        this.deployments = data && data['deployments'] ? data['deployments'] : [];
        this.validHours = data && data['validHours'] ? data['validHours'] : 0;
    }
}
